import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const DISMISS_KEY = "newsletter_popup_dismissed";

export default function NewsletterPopup() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (user) return;
    if (localStorage.getItem(DISMISS_KEY)) return;
    let t;
    const start = () => { t = setTimeout(() => setShow(true), 6000); };
    if (localStorage.getItem("cookie_consent")) {
      start();
      return () => clearTimeout(t);
    }
    const onDecided = () => start();
    window.addEventListener("cookie:decided", onDecided, { once: true });
    return () => { window.removeEventListener("cookie:decided", onDecided); clearTimeout(t); };
  }, [user]);

  const close = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  return (
    <AnimatePresence>
      {show && !user && (
        <motion.div
          role="dialog"
          aria-modal="false"
          aria-label="Iscrizione newsletter"
          data-testid="newsletter-popup"
          initial={{ opacity: 0, y: 40, scale: 0.98 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.98 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed z-[60] bottom-6 left-6 max-sm:right-6 sm:w-[380px] bg-ink text-bone shadow-2xl border border-white/10"
        >
          <button
            data-testid="newsletter-popup-close"
            onClick={close}
            aria-label="Chiudi"
            className="absolute top-3 right-3 text-bone/50 hover:text-bone transition-colors p-1"
          >
            <X size={18} />
          </button>
          <div className="p-7">
            <p className="text-[11px] uppercase tracking-[0.25em] text-claret-soft mb-3">La newsletter</p>
            <h3 className="font-serif-display text-3xl leading-tight">
              Iscriviti alla newsletter
            </h3>
            <p className="text-sm text-bone/60 mt-3 leading-relaxed">
              Iscriviti per ricevere le nostre selezioni e un codice sconto del 10% da usare subito.
            </p>
            <Link
              to="/register"
              onClick={close}
              data-testid="newsletter-popup-cta"
              className="mt-5 inline-flex items-center justify-center w-full bg-claret hover:bg-claret-dark text-bone min-h-[48px] px-6 uppercase tracking-[0.15em] text-xs transition-colors"
            >
              Iscriviti e risparmia
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
